export default __webpack_public_path__ + "static/toolkit_card-8ea90e192a3af706cdae3e45ee6b5615.jpeg";